import styled from '@emotion/styled';
import { baseWidths, colors, header } from 'src/theme';
import { mediaQuery, useMessage } from 'src/common';
import { keyframes } from '@emotion/react';
import { Text } from '../typography';

export const Message = () => {
  // const { visible, message, duration, backgroundColor } = useAppSelector((state) => state.state.message);

  // useEffect(() => {
  //   if (visible) {
  //     const timer = setTimeout(() => {
  //       dispatch(hideMessage());
  //     }, duration);

  //     return () => clearTimeout(timer);
  //   }

  //   return undefined;
  // }, [visible, duration, dispatch]);

  const { visible, message, backgroundColor, isExiting, fixed, color } = useMessage();

  const slideInFromTop = keyframes`
    0% {
      transform: translateY(-100%);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  `;

  const slideOutToTop = keyframes`
    0% {
      transform: translateY(0);
      opacity: 1;
    }
    100% {
      transform: translateY(-100%);
      opacity: 0;
    }
  `;

  const MessageStyle = styled.div({
    position: fixed ? 'fixed' : 'static',
    top: fixed ? header.height + 60 : 'auto',
    zIndex: 90,
    borderRadius: 6,
    padding: '8px 6px',
    backgroundColor: backgroundColor || colors.primary5,
    animation: visible && !isExiting 
    ? `${slideInFromTop} 0.5s ease-in-out`
    : `${slideOutToTop} 0.5s ease-in-out`,
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 12,
    
    ...(fixed && {
      left: '50%',
      marginLeft: '-250px',
      width: '500px',
    }),

    [mediaQuery('mobile')]: {
      ...(fixed ? {
        left: '50%',
        marginLeft: '-300px',
        width: '600px',
      } : {
        width: `${baseWidths.mobile}px`
      })
    },
  });

  return visible ? (
    <MessageStyle>
      <Text type="small" color={color}>
        {message}
      </Text>
    </MessageStyle>
  ) : null;
};
